<template>
  <div class>
    <STable
      ref="tableref"
      :url="url"
      :selection="false"
      :columns="columns"
      :handles="handles"
      :query="query"
      :toolbar="toolbar"
      label-width="120px"
    />

    <el-dialog
      v-dialogDrag
      title="分配成员"
      :visible.sync="dialogVisibleUser"
      :close-on-click-modal="false"
      width="40%"
      center
    >
      <el-input
        v-model="filterText1"
        placeholder="输入关键字进行过滤"
      />
      <el-tree
        ref="usertree"
        :data="usertree"
        show-checkbox
        :props="defaultProps"
        :filter-node-method="filterNode1"
        node-key="id"
        :default-checked-keys="list"
      />
      <div class="btns" style="margin-top:30px; display: flex; align-items: center; justify-content:center;">
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="save">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog
      v-dialogDrag
      title="菜单权限"
      :visible.sync="dialogVisibleMenu"
      :close-on-click-modal="false"
      width="40%"
      center
    >
      <div class="border">
        <el-input
          v-model="filterText"
          placeholder="输入关键字进行过滤"
        />
        <el-tree
          ref="menutree"
          :data="menutree"
          show-checkbox
          :props="defaultProps"
          :default-checked-keys="list1"
          :filter-node-method="filterNode"
          node-key="id"
          :check-strictly="checkStrictly"
          @check="checkChange"
        />
      </div>
      <!-- <el-tree
        :data="menutree"
        show-checkbox
        :props="defaultProps"
        :filter-node-method="filterNode"
        node-key="id"
        :default-checked-keys="list1"
        ref="menutree">
      </el-tree> -->
      <!-- <el-tree
        :data="menutree"
        ref="menutree"
        show-checkbox :props="defaultProps"
        :default-checked-keys="list1"
        node-key="id"
        @check-change="checkChange">
      </el-tree> -->
      <div class="btns" style="margin-top:30px; display: flex; align-items: center; justify-content:center;">
        <el-button @click="cancel1">取消</el-button>
        <el-button type="primary" @click="save1">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'Jueseguanli',
  components: {},
  data() {
    return {
      url: '/auth/role/page',
      components: {},
      checkStrictly: true,
      columns: [
        {
          label: '角色名称',
          prop: 'name'
        },
        {
          label: '创建人',
          prop: 'creater'
        },
        {
          label: '创建时间',
          prop: 'createDate'
        }
      ],
      handles: {
        width: 400,
        btns: [
          {
            label: '修改',
            icon: 'el-icon-edit',
            permission: 'power.role.update',
            handle: res => {
              this.$router.push({ path: './reviserole', query: { data: res.id }})
            }
          },
          {
            label: '分配成员',
            icon: 'el-icon-place',
            permission: 'power.role.distributeMember',
            before: (index, record) => {
              this.id = record.id
              this.usertree = []
              this.list = []
              const data = {
                id: record.id
              }
              // 获取分配成员树
              this.$store.dispatch('form/handle', {
                url: '/auth/user/findUserAuthRes',
                method: 'get',
                callback: resp => {
                  // this.usertree = resp
                  var usertreeData = resp

                  this.$store.dispatch('form/handle', {
                    url: '/auth/role',
                    data: data,
                    method: 'get',
                    callback: resp => {
                      for (let i = 0; i < resp.userList.length; i++) {
                        this.list.push(resp.userList[i])
                      }
                      this.usertree = usertreeData
                    } })
                }
              })
              this.dialogVisibleUser = true
            }
          },
          {
            label: '菜单权限',
            permission: 'power.role.menu',
            style: 'color:red',
            before: (index, record) => {
              this.id = record.id
              this.menutree = []
              this.list1 = []
              // 获取菜单权限树
              const data = {
                bizType: 'menu'
              }
              this.$store.dispatch('form/handle', {
                url: '/auth/findMy',
                data: data,
                method: 'get',
                callback: resp => {
                  this.menutree = resp[1]
                }
              })
              this.dialogVisibleMenu = true
            },
            handle: resp => {
              const data = {
                id: resp.id
              }
              this.$store.dispatch('form/handle', {
                url: '/auth/role',
                data: data,
                method: 'get',
                callback: resp => {
                  for (let i = 0; i < resp.authList.length; i++) {
                    if (resp.authList[i].bizType === 'menu') {
                      this.list1.push(resp.authList[i].bizKey)
                    }
                  }
                }
              })
            }
          }
          // {
          //   label: "删除",
          //   permission: "power.role.delete",
          //   style: "color:red",
          //   url: "/auth/role",
          //   method: "delete",
          //   isConfirm: true,
          //   before: (index, records) => {
          //     let arr = [];
          //     arr.push(records.id);
          //     return {
          //       ids: arr
          //     };
          //   },
          //   handle: () => {
          //     this.$refs.tableref.queryTable();
          //   }
          // }
        ]
      },
      query: [
        {
          label: '角色名称',
          prop: 'keywords',
          placeholder: '请输入角色名称'
        }
      ],
      toolbar: [
        {
          label: '新增',
          permission: 'power.role.add',
          type: 'primary',
          handle: resp => {
            this.$router.push('./addrole')
          }
        }
      ],
      dialogVisibleUser: false,
      dialogVisibleMenu: false,
      userIds: [],
      usertree: [],
      permissionIds: [],
      menutree: [],
      rowdata: {},
      id: '',
      filterText: '',
      filterText1: '',
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      list: [],
      list1: [],
      aa: ''
    }
  },
  computed: {},
  watch: {
    filterText(val) {
      this.$refs.menutree.filter(val)
    },
    filterText1(val) {
      this.$refs.usertree.filter(val)
    }
  },
  mounted() {
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {

  },
  methods: {
    cancel() {
      this.userIds = []
      this.dialogVisibleUser = false
    },
    checkChange(data) { // 通过check的回调里面获取节点id,再获取节点的node对象\
      const node = this.$refs.menutree.getNode(data.id)
      this.setNode(node)
    },
    setNode(node) { // 递归设置子节点和父节点
      if (node.checked) {
      // 如果当前是选中checkbox,则递归设置父节点和父父节点++选中
        this.aa = node.label
        this.setParentNode(node, 0)
        // this.setChildNode2(node)
      } else {
      // 如果当前是取消选中checkbox,则递归设置子节点全部取消选中
        this.setChildNode(node)
      }
    },
    setParentNode(node, index) { // 递归设置父节点全部选中
      // console.log(node,'node父',index)
      if (node.parent) {
        // console.log('有父')
        for (const key in node) {
          if (key === 'parent') {
            node[key].checked = true
            if (node.level > 2) {
              this.setParentNode(node[key], index + 1)
            }
            if (node.level >= 1 && index === 0) {
              this.setChildNode2(node, 0)
            }
          }
        }
      }
    },
    setChildNode(node) { // 递归设置子节点全部取消选中
      if (node.childNodes && node.childNodes.length) {
        node.childNodes.forEach(item => {
          item.checked = false
          this.setChildNode(item)
        })
      }
    },
    setChildNode2(node, aa) { // 设置子节点全部选中
      if (node.childNodes && node.childNodes.length > 0) {
        node.childNodes.forEach(item => {
          item.checked = true
          this.setChildNode2(item, aa + 1)
        })
      }
    },

    save() {
      this.userIds = []
      const nodes = this.$refs.usertree.getCheckedNodes(true, false)
      for (var i = 0; i < nodes.length; i++) {
        const node = nodes[i]
        if (!node.noData) {
          this.userIds.push({
            id: node.id
          })
        }
      }

      const data = {
        id: this.id,
        userList: this.userIds
      }
      console.log(data)
      this.$store.dispatch('form/handle', {
        url: '/auth/role',
        data: data,
        method: 'post',
        callback: resp => {
          this.dialogVisibleUser = false
        }
      })
    },

    cancel1() {
      this.permissionIds = []
      this.dialogVisibleMenu = false
    },

    // 保存菜单权限
    save1() {
      console.log(this.permissionIds)
      this.permissionIds = []
      const nodes = this.$refs.menutree.getCheckedNodes(false, true)
      for (var i = 0; i < nodes.length; i++) {
        const node = nodes[i]
        if (!node.noData) {
          this.permissionIds.push(node.id)
        }
      }
      const data = {
        roleId: this.id,
        data: {
          menu: this.permissionIds
        }
      }
      this.$store.dispatch('form/handle', {
        url: '/auth',
        data: data,
        method: 'put',
        callback: resp => {
          this.dialogVisibleMenu = false
        }
      })
    },

    filterNode(value, data, node) {
      if (!value) return true
      let parentNode = node.parent
      let labels = [node.label]
      let level = 1
      while (level < node.level) {
        labels = [...labels, parentNode.label]
        parentNode = parentNode.parent
        level++
      }
      return labels.some(label => label.indexOf(value) !== -1)
    },

    filterNode1(value, data, node) {
      if (!value) return true
      let parentNode = node.parent
      let labels = [node.label]
      let level = 1
      while (level < node.level) {
        labels = [...labels, parentNode.label]
        parentNode = parentNode.parent
        level++
      }
      return labels.some(label => label.indexOf(value) !== -1)
    }
  } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style lang="less" src="" scoped>
  .SForm{
    margin-left: 150px;
  }
  .border {
    border: 1px solid #EEEEEE;
    padding: 20px;
    height: 300px;
    overflow-y: auto;
  }
</style>



// WEBPACK FOOTER //
// src/views/userManagement/rolemanagement.vue